// Landing page for the Shopify OAuth callback. ShopifyService redirects the top
// window here after install: /Manage/Connections?shopify=connected|denied|error.
// Confirms the real-time connection and routes onward. Same ob- design system
// as onboarding. (Gap-1 companion to shopify-connect.jsx's "Connect with Shopify".)

import React from "react";
import { withRouter } from "react-router";
import { OB_CSS } from "../onboarding/onboarding-css";
import { clearOnboardingCache } from "../../functions/onboarding-status";
class ManageConnectionsView extends React.Component {
  constructor(props) {
    super(props);
    const q = new URLSearchParams(window.location.search || "");
    this.status = (q.get("shopify") || "").toLowerCase();
    // A fresh connection invalidates the cached onboarding/status snapshot.
    try {
      if (this.status === "connected") clearOnboardingCache();
    } catch (e) {/* noop */}
  }
  render() {
    const ok = this.status === "connected";
    const denied = this.status === "denied" || this.status === "access_denied";
    // conflict (2026-11-03): one Shopify store per workspace — the store is already bound elsewhere, or this
    // workspace already has a different store connected.
    const conflict = this.status === "conflict";
    const boundShop = (() => {
      try {
        return new URLSearchParams(window.location.search || "").get("bound") || "";
      } catch (e) {
        return "";
      }
    })();
    const icon = ok ? "check" : "error_outline";
    const title = ok ? "Shopify connected" : denied ? "Connection cancelled" : conflict ? "That store can't be connected here" : "Couldn't finish connecting";
    const msg = conflict ? boundShop ? `This workspace is already connected to ${boundShop}. Plunk supports one Shopify store per workspace: disconnect it first, or install Plunk on the other store with a different contact email to get a separate workspace.` : "This store is already connected to another Plunk workspace. Uninstall Plunk there first, or email support@plunk.io and we'll move it." : ok ? "Your store is connected in real time. Products, orders, customers and inventory now sync via webhooks; the first backfill runs now and appears under Sales, Customers and Social within a few minutes." : denied ? "The install was cancelled in Shopify, so nothing was connected. You can start again whenever you're ready." : "Something went wrong finishing the Shopify connection. Please try connecting again, or email support@plunk.io if it keeps happening."; // no token-paste copy for Shopify tenants (2026-11-03)
    return /*#__PURE__*/React.createElement("div", {
      className: "ob-root"
    }, /*#__PURE__*/React.createElement("style", null, OB_CSS), /*#__PURE__*/React.createElement("div", {
      className: "ob-wrap",
      style: {
        maxWidth: 720
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-eyebrow"
    }, "Manage \xB7 connections \xB7 Shopify"), /*#__PURE__*/React.createElement("div", {
      className: "ob-sec",
      style: {
        textAlign: "center",
        padding: "34px 24px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-mark",
      style: {
        margin: "0 auto 14px"
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      style: {
        fontSize: 26
      }
    }, icon)), /*#__PURE__*/React.createElement("div", {
      className: "lab",
      style: {
        fontSize: 16
      }
    }, title), /*#__PURE__*/React.createElement("p", {
      className: "ob-hint",
      style: {
        maxWidth: "52ch",
        margin: "8px auto 0"
      }
    }, msg), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 16,
        display: "flex",
        gap: 8,
        justifyContent: "center",
        flexWrap: "wrap"
      }
    }, ok ? [/*#__PURE__*/React.createElement("button", {
      key: "social",
      className: "ob-btn",
      onClick: () => this.props.history.push("/Social")
    }, "Go to Social"), /*#__PURE__*/React.createElement("button", {
      key: "setup",
      className: "ob-btn ghost",
      onClick: () => this.props.history.push("/Setup")
    }, "Back to setup")] : /*#__PURE__*/React.createElement("button", {
      className: "ob-btn",
      onClick: () => this.props.history.push("/Shopify")
    }, "Try again")))));
  }
}
export default withRouter(ManageConnectionsView);
export const ManageConnectionsViewComponent = withRouter(ManageConnectionsView);